import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';

import PercentageDoughnut from 'src/components/planAction/PlanActionStatisticsPage/components/PercentageDoughnut';

interface FractionDisplayProps {
  denominator?: number;
  nominator: number;
  label: string;
  showNA?: boolean;
  bigText?: boolean;
}

const FractionDisplay: FC<FractionDisplayProps> = ({
  nominator,
  denominator,
  showNA = false,
  label = '',
  bigText = false,
}) => {
  const { t } = useTranslation('common');

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        mx: 2,
      }}
    >
      <PercentageDoughnut
        nominator={nominator}
        denominator={denominator}
        showNA={showNA}
      />
      <Stack
        direction="column"
        spacing={1}
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: 30,
              lineHeight: '1.75rem',
            }}
          >
            {!showNA ? `#${nominator}` : 'n/a'}
          </Typography>
          <Typography
            sx={{
              fontSize: bigText ? 22 : 13,
            }}
          >
            {t('of')}
          </Typography>
          <Typography
            sx={{
              fontSize: 30,
              lineHeight: '1.75rem',
            }}
          >
            {!showNA ? `#${denominator}` : 'n/a'}
          </Typography>
        </Box>
        <Typography
          sx={{
            textAlign: 'center',
            fontSize: bigText ? 22 : 13,
          }}
        >
          {label}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default FractionDisplay;
